import React, { useState } from "react";
import "./styles.scss";
import Layout from "../../components/Layout/Layout";
import { Link, useHistory } from "react-router-dom";
import { Spinner } from "reactstrap";
import storeId from "../../config/storeId";

import Axios from "axios";
import { BASE_URL } from "../../redux/constants";
import Auth from "../../config/auth";
import { useEffect } from "react";

const StoreHome = (props) => {
  const storeName = storeId();
  const history = useHistory()
  const [store, setStore] = useState({})
  const [msg, setMsg] = useState()
  // Remove saved data from sessionStorage
  // sessionStorage.removeItem("order_id");
  async function viewStore() {
    const token = Auth.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    try {
      const response = await Axios.get(
        `${BASE_URL}/products/view/all/${storeName}`,
        token != null && ({
          headers
        })
      );
      if (response.data.hasError) {
        console.log(response.data);
      } else {
        //setStore(response.data.data.store);
        const {store} = response.data.data
        console.log(response.data.data.store);
        setStore(store)
        if(store.published){
          if(store.template_id === 1){
            history.push('/store')
          } else {
            history.push('/store-two')
          }
        } else {
          setMsg(<div>
            <h1>{storeName} is currently not active</h1>
            <h6>Please contact shobbu admin</h6>
          </div>  )
        }
       
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(()=>{
    viewStore();
  },[])



  return (
      <section className="">
        <div className="p-2">
          <div className="order-placed-container">
            <div className="text-center">
              <h1>Welcome to {storeName}</h1>
              {/* <h6>Fetching your items</h6> */}
              <div className="row p-4">
                <div className="col-md-12">
                  {!store.published ? 
                  msg :  <Spinner
                  animation="border"
                  variant="primary"
                  className="p-3 m-3"
                />
                }
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  );
};

export default StoreHome;
